import { PERSON_DOB_API_FORMAT } from 'constants/date-options'
import { MAX_CHARS_PERSONA_DETAIL, MAX_CHARS_PERSON_NAMES, MAX_CHARS_WHERE_DID_YOU_HEAR_DETAIL, MIN_CHARS_PERSONA_DETAIL, MIN_CHARS_PERSON_NAMES, MIN_CHARS_WHERE_DID_YOU_HEAR_DETAIL } from 'constants/registration'
import { MAX_HEIGHT_METRIC, MIN_HEIGHT_METRIC } from 'forms/common/constants'
import moment from 'moment'
import { SexEnum } from 'types/api/enums'
import { isEmailAddressValid, isFormattedDateValid } from 'utils'

const VALID_SEXES = Object.values(SexEnum)

export const validators = {
  doesExist: (error: string | boolean | object) => (key, value, errors) => {
    let isValid = true
    if (!value) {
      if (typeof error === 'object') {
        for (let key in error) {
          errors[key] = error[key]
        }
      } else {
        errors[key] = error
      }
      isValid = false
    }
    return isValid
  },

  isNameValidLength: (error: string | boolean) => (key, value, errors) => {
    let isValid = true

    const minLength = key === 'personaDetail' ? MIN_CHARS_PERSONA_DETAIL : MIN_CHARS_PERSON_NAMES
    const maxLength = key === 'personaDetail' ? MAX_CHARS_PERSONA_DETAIL : MAX_CHARS_PERSON_NAMES

    if (!value || value.length < minLength || value.length > maxLength) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },

  isDetailValidLength: (error: string | boolean) => (key, value, errors) => {
    let isValid = true

    if (value.length < MIN_CHARS_WHERE_DID_YOU_HEAR_DETAIL || value.length > MAX_CHARS_WHERE_DID_YOU_HEAR_DETAIL) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },

  isSexValid: (error: string | boolean) => (key, value, errors) => {
    let isValid = true
    if (!VALID_SEXES.includes(value)) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },

  isDateFormatValid: (error: object) => (_key, value, errors) => {
    let isValid = true
    if (!value || value.length !== PERSON_DOB_API_FORMAT.length || !isFormattedDateValid(value)) {
      for (let key in error) {
        errors[key] = error[key]
      }

      isValid = false
    }
    return isValid
  },

  isDateInThePast: (error: object) => (_key, value, errors) => {
    let isValid = true
    if (new Date(value) >= new Date()) {
      for (let key in error) {
        errors[key] = error[key]
      }

      isValid = false
    }
    return isValid
  },

  isOfMinAge: (error: object, minAge: number) => (_key, value, errors) => {
    let isValid = true
    if (moment().diff(value, 'years') < minAge) {
      for (let key in error) {
        errors[key] = error[key]
      }

      isValid = false
    }
    return isValid
  },

  isAboveMinHeight: (error: string) => (key, value, errors) => {
    if (!value) return true
    let isValid = true

    if (value < MIN_HEIGHT_METRIC) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },

  isUnderMaxHeight: (error: string) => (key, value, errors) => {
    let isValid = true
    if (value > MAX_HEIGHT_METRIC) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },

  isEmailValid: (error: string) => (key, value, errors) => {
    let isValid = true
    if (!isEmailAddressValid(value)) {
      errors[key] = error
      isValid = false
    }
    return isValid
  },
}

const makeFieldValidator = (values, validationSchema) => (key, errors) => {
  const validateArr = validationSchema[key]
  const valueToValidate = values[key]
  if (validateArr && validateArr.length) {
    for (let i = 0; i < validateArr.length; i++) {
      if (!validateArr[i](key, valueToValidate, errors)) break
    }
  }

  return errors
}

export const makeValidationFunc = (fieldsToValidate: string[], validationSchema) => values => {
  const validate = makeFieldValidator(values, validationSchema)
  const errors = fieldsToValidate.reduce((errors, field) => {
    return validate(field, errors)
  }, {})
  return errors
}
